<dx-menubar #menubar *ngIf="loggedOnUser" [menuItems]="appMenuItems" [adjacentItems]="rightMenuBarItems"></dx-menubar>
<div class="spinner-loader" *ngIf="authSvc.showLoader">
    <p-progressSpinner></p-progressSpinner>
</div>
<router-outlet></router-outlet>


